import React from 'react';
import { Link } from 'react-router-dom';
import { Newspaper } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { getCategoryMeta, getPublicationHref } from '../lib/newsPublications';

const DEFAULT_IMAGE = '/logo.svg';

const NewsPublicationCard = ({ item, onOpen }) => {
  const href = getPublicationHref(item);
  const categoryLabel = getCategoryMeta(item.category).label;

  const content = (
    <Card className="bg-white rounded-lg overflow-hidden shadow-md border border-border/50 hover:shadow-xl hover:border-accent/30 transition-all duration-300 h-full">
      {item.image && (
        <div className="w-full h-44 sm:h-48 bg-gray-100 overflow-hidden flex items-center justify-center">
          <img
            src={item.image}
            alt={item.title}
            className={`max-w-full max-h-full ${
              item.category === 'blog' ? 'w-full h-full object-cover' : 'object-contain'
            }`}
            onError={(e) => {
              e.target.src = DEFAULT_IMAGE;
            }}
          />
        </div>
      )}
      <CardContent className="p-5 sm:p-6">
        <div className="flex flex-wrap items-center gap-2 text-xs sm:text-sm mb-3">
          <span className="inline-flex items-center rounded-full bg-accent/10 text-accent px-2.5 py-0.5 font-medium">
            {categoryLabel}
          </span>
          <span className="inline-flex items-center gap-1 text-muted-foreground">
            <Newspaper className="w-3.5 h-3.5" />
            {item.date}
          </span>
          {item.readTime && (
            <span className="text-muted-foreground">{item.readTime} чтения</span>
          )}
        </div>
        <h3 className="text-lg font-semibold mb-2 line-clamp-2 group-hover:text-accent transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-muted-foreground line-clamp-3 mt-2">{item.description}</p>
        <span className="inline-block mt-4 text-sm font-medium text-accent">
          {href ? 'Читать →' : 'Подробнее →'}
        </span>
      </CardContent>
    </Card>
  );

  if (href) {
    if (href.startsWith('http')) {
      return (
        <a href={href} className="block group h-full" target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      );
    }
    return (
      <Link to={href} className="block group h-full">
        {content}
      </Link>
    );
  }

  return (
    <button
      type="button"
      onClick={() => onOpen?.(item)}
      className="block group h-full w-full text-left cursor-pointer"
    >
      {content}
    </button>
  );
};

export default NewsPublicationCard;
